import Box from '@mui/material/Box';

import { RenewMemberFileCard, RenewMemberNewCard } from 'routes/renewMember/components';

const RenewMemberOptions = ({ renewInfo, setPaymentStatus }) => {
	const hasSavedCard = Boolean(renewInfo?.card_details);

	return (
		<>
			{hasSavedCard && (
				<Box sx={{ mb: 2 }}>
					<RenewMemberFileCard setPaymentStatus={setPaymentStatus} renewInfo={renewInfo} />
				</Box>
			)}

			<RenewMemberNewCard setPaymentStatus={setPaymentStatus} renewInfo={renewInfo} />
		</>
	);
};

export default RenewMemberOptions;
